import Vue from 'vue';

import Vuetify, {
    VApp,
    VAutocomplete,
    VBtn,
    VBtnToggle,
    VCard,
    VCheckbox,
    VDataTable,
    VDatePicker,
    VFooter,
    VForm,
    VIcon,
    VList,
    VMenu,
    VProgressLinear,
    VNavigationDrawer,
    VSelect,
    VSnackbar,
    VSwitch,
    VTabs,
    VTextarea,
    VTextField,
    VToolbar,
    VTooltip
} from 'vuetify/lib';

import VGrid from 'vuetify/es5/components/VGrid';
import transitions from 'vuetify/es5/components/transitions';

import fr from 'vuetify/src/locale/fr';

Vue.use(Vuetify, {
    components: {
        VApp,
        VAutocomplete,
        VBtn,
        VBtnToggle,
        VCard,
        VCheckbox,
        VDataTable,
        VDatePicker,
        VFooter,
        VForm,
        VGrid,
        VIcon,
        VList,
        VMenu,
        VProgressLinear,
        VNavigationDrawer,
        VSelect,
        VSnackbar,
        VSwitch,
        VTabs,
        VTextarea,
        VTextField,
        VToolbar,
        VTooltip,
        transitions
    },
    theme: {
        primary: '#0069a7', // Dark blue.
        secondary: '#0af', // Light blue.
        accent: '#008737' // Green.
    }
});

export default new Vuetify(
    {
        lang: {
            locales: { fr },
            current: 'fr'
        },
    }
);
